import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "confirm-dialog" }
const _hoisted_2 = { class: "confirm-dialog__message" }
const _hoisted_3 = { class: "confirm-dialog__buttons" }

interface Props {
  message: string
  confirmText: string
  cancelText: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    message: null,
    confirmText: null,
    cancelText: null
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'confirm'): void,
  (event: 'cancel'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  message: string
  confirmText: string
  cancelText: string
};





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.message), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('cancel')))
      }, _toDisplayString(__props.cancelText), 1),
      _createElementVNode("label", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('confirm')))
      }, _toDisplayString(__props.confirmText), 1)
    ])
  ]))
}
}

})